import type { HTMLAttributes, PropsWithChildren } from 'react'

import { cn } from '@/lib/utils'

export function PageContainer({
  className,
  children,
  ...props
}: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  return (
    <div
      className={cn('mx-auto w-full max-w-7xl px-3 md:px-4 lg:px-5', className)}
      {...props}
    >
      {children}
    </div>
  )
}
